/** 自定义导出请求 */
import { Axios } from 'choerodon-ui/pro';
import qs from 'query-string';
import notification from 'utils/notification';
import { getCurrentOrganizationId, getAccessToken } from 'utils/utils';
import intl from 'utils/intl';
import { API_HOST } from 'utils/config';
import { requestGet } from '@common/utils/request.js';
import moment from 'moment';
import { isOverseaEnv } from '.';

/**
 * 点击下载文件
 * @param {string} url - 文件的url
 * @param {string} name - 文件全名(包含后缀)
 * @param {string} bucketName - 桶名
 */
interface DownloadFileProps {
  url: string;
  name: string;
  bucketName?: string;
}

export const getBucketName = ()=> isOverseaEnv()? 'sany-cbms': 'hpfm';

export const getDownloadFileUrl = ({ url, fileName, bucketName = 'hpfm' }: DownloadFileProps) => {
  const requestUrl = `${API_HOST}${isOverseaEnv()? `/station/v1/${getCurrentOrganizationId()}/station-infos/storage/file/download` : `/device/v1/${getCurrentOrganizationId()}/common-file/filePreview`}`;
  if (!url) {
    return notification.error({
      message: intl.get('cbms.common.view.failure').d('失败'),
      description: intl.get('cbms.other.view.fileUrlNotExst').d('文件路径不存在'),
    });
  }
  return `${requestUrl}?address=${url}&bucketName=${bucketName}&fileName=${name}`;
};

export function getFileNameWithoutExt(filename) {
  const lastIndex = filename.lastIndexOf('.');
  // 如果找不到点，返回整个字符串
  if (lastIndex === -1) {
    return filename;
  }
  // 截取从开始到最后一个点之前的部分
  return filename.substring(0, lastIndex);
}



export const downloadFile = (params) => {
  // ?address=${url}&bucketName=${bucketName}
  const requestUrl = `${isOverseaEnv()? `/station/v1/${getCurrentOrganizationId()}/station-infos/storage/file/download` : `/device/v1/${getCurrentOrganizationId()}/common-file/filePreview`}`;
  return requestGet(requestUrl, {
    query: params,
    responseType: 'blob',
  })
    .then(async(res) => {
      if (!res) return;
      try {
        const resBlob = await res.blob();
        const blob = new Blob([resBlob as unknown as Blob], {
          type: 'application/octet-stream;charset=utf-8',
        });
        const fileName = `${params.fileName}`;
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);
        document.body.removeChild(elink);
      } catch (error) {
        notification.error({
          message: intl.get('hzero.common.message.confirm.title').d('提示'),
          description: intl.get('hzero.common.components.reportExport.downloadFailed').d('下载失败'),
        });
      }
    })
    .finally(() => {
      // eslint-disable-next-line no-unused-expressions
      // callback?.();
    });
};

export const getFileListByUuid = (attachmentUUID)=>{
  return Axios.get(
    `${API_HOST}/hfle/v1/${getCurrentOrganizationId()}/files/${attachmentUUID}/file`,
    {
      headers: {
        Authorization: `bearer ${getAccessToken()}`,
      },
    }
  ).then((response: any) => {
    return response.map((file) => ({
      uid: attachmentUUID,
      name: file.fileName,
      size: file.fileSize,
      type: file.fileType,
      url: file.fileUrl,
      bucketName: file.bucketName,
      creationDate: moment(file.creationDate).toDate(),
      status: 'done',
    }));
  });
};
